import { Component, Input, OnInit, TemplateRef, EventEmitter, Output } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_List_Interface, Empty_Calibration_List_Interface } from 'src/app/Interface/Calibration_List_Interface';
import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_Kartable_Order_Interface, Kartable_Order_Interface } from 'src/app/Interface/Kartable_Order_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { KartableService } from 'src/app/Service/Kartable/Kartable.service';
import { LabService } from 'src/app/Service/Lab/Lab.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-CalibrationInPositionCertificate',
  templateUrl: './CalibrationInPositionCertificate.component.html',
  styleUrls: ['./CalibrationInPositionCertificate.component.scss']
})
export class CalibrationInPositionCertificateComponent implements OnInit {

  @Input() inner_Calibration: Calibration_List_Interface = Empty_Calibration_List_Interface()
  @Output() OnBack_Calibration_Action = new EventEmitter<number>();
  Token: String = ""
  PersianToDayDate: String = ""
  certificate_user_code: String = ""
  BaseUrl = environment.BaseUrl
  Controller_Data_List: Array<General_Interface> = []
  page_Kartable: 0

  Filter_Customer_Order: string = ""
  Filter_RecieveCode_Order: string = ""
  Filter_Code2_Order: string = ""
  Filter_Devicename_Order: string = ""
  Filter_Expert_Name_Order: string = ""


  constructor(
    private Kartable_Service: KartableService,
    private Alertify_Service: AlertifyService,
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private Lab_Service: LabService,
    private Calibration_Service: CalibrationService,
    private modalService: BsModalService
  ) { }


  OnSet_Back_CalibrationList() {
    this.OnBack_Calibration_Action.emit(-1);

  }


  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');

  }


  Procssing_Kartable: boolean = false
  DataList_Kartable: Array<Kartable_Order_Interface> = []
  DataList_Kartable_Selected: Kartable_Order_Interface = Empty_Kartable_Order_Interface()
  Data_Seleted_Delete_Status: number = 0
  OperationDsc: string = ''
  modalRef_Delete: any;

  DataList_Calibration_Device: Array<DeviceBehfa_Interface> = []
  ReadData_Kartable() {
    this.Procssing_Kartable = true
    this.Kartable_Service.GetCalibrationInLocation(this.Token, this.inner_Calibration.id).subscribe(
      data => {
        this.DataList_Kartable = data['outer']
        this.DataList_Calibration_Device = data['devicebehfa']

        this.Procssing_Kartable = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  SubmitExpertCalibrationDate(item: Kartable_Order_Interface) {

    item.Processing = true
    this.Lab_Service.SubmitExpertCalibrationDate(item.calibration_detail_id,
      this.Token).subscribe(
        data => {
          item.status = 'کنترل'
          item.Processing = false
        }, error => {
          localStorage.clear()
          location.reload();

        }
      )
  }

  //#region Upload Word

  modalRef_upload: any;
  ProcssingUpload: boolean = false

  Selected_DataList_Calibration: Kartable_Order_Interface = Empty_Kartable_Order_Interface();
  openModal_upload(template: TemplateRef<any>, item: Kartable_Order_Interface) {
    this.modalRef_upload = this.modalService.show(template);
    this.Selected_DataList_Calibration = item
    this.certificate_user_code = item.certificate_user_code
  }

  onFileSelected(event) {
    if(event.target.files.length > 0) 
     {
      this.certificate_user_code= event.target.files[0].name;
      this.certificate_user_code = this.certificate_user_code.replace(".docx","").replace(".doc","")
     }
   }

  upload(files) {
    if (files.length === 0)
      return;

    else if (!this.certificate_user_code) {
      this.Alertify_Service.ErrorMessage("Enter the certificate code.")
    }
    else {
      const formData = new FormData();

      for (const file of files) {
        formData.append(file.name, file);
      }

      this.ProcssingUpload = true

      this.Calibration_Service.uploadFileCertificate(formData, this.Selected_DataList_Calibration.id2, this.Token, this.certificate_user_code).subscribe(
        data => {
          this.ProcssingUpload = false
          if (data['id'] == 0) {
            this.Alertify_Service.ErrorMessage(data['filename'])
          }
          else {

            this.Alertify_Service.SuccessMessage("Information saved successfully.")

            this.Selected_DataList_Calibration.filename = data['filename']

          }
        }
      )
    }
  }

  //#endregion

  //#region Controller

  modalRef_Controller: any;

  openModal_Controller(template: TemplateRef<any>, item: Kartable_Order_Interface) {
    this.modalRef_Controller = this.modalService.show(template);
    this.Selected_DataList_Calibration = item
    this.Controller_Data_List = item.controller
  }

  //#endregion

  //#region LetterFile

  modalRef_LetterFile: any;
  LetterFile_Data_List: Array<string> = []
  LetterFile_Data_Code:string = ""
  LetterFile_Data_Tarikh:string = ""
  openModal_LetterFile(template: TemplateRef<any>, item: Kartable_Order_Interface) {
    this.modalRef_LetterFile = this.modalService.show(template);
    this.LetterFile_Data_Code=''
    this.LetterFile_Data_List=[]
    this.LetterRequestCustomer_Service.GetLetterRequestCustomerImage(Number(item.code2), this.Token).subscribe(
      data => {
        this.LetterFile_Data_List = data['record']
        this.LetterFile_Data_Code = data['code']
        this.LetterFile_Data_Tarikh = data['bazgasht']
      }
    )
  }

  //#endregion


  DataList_Kartable_Selected_DeviceBehfa: Kartable_Order_Interface = Empty_Kartable_Order_Interface()
  CanModify_Kartable_Selected_DeviceBehfa: boolean = false
  OnSet_Calibration_DeviceBehfa(item: Kartable_Order_Interface, canModify: number) {
    this.DataList_Kartable_Selected_DeviceBehfa = item
    this.CanModify_Kartable_Selected_DeviceBehfa = (canModify == 1)
  }

  OnSet_Back_Calibration_DeviceBehfa() {
    this.DataList_Kartable_Selected_DeviceBehfa = Empty_Kartable_Order_Interface()
  }


  exportexcel(): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, "BehfaDevice.xlsx");

  }


}
